// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6e78de92","559":"33fe21e9","651":"6eca4ce9"}[chunkId] + ".chunk.js";
};